
import React, { useEffect, useRef, useState } from "react";
import Pagination from "../../Components/Pagination/Pagination.jsx";
import "../Users/style.scss";
import { useLocation, useNavigate } from "react-router-dom";
import { CSVLink } from "react-csv";

import "jspdf-autotable";

import "sweetalert2/dist/sweetalert2.min.css";
import {  getCustomer, updateCustomerStatus } from "../../utils/api.js";
import {
  isEmpty,
  pdfData,

} from "../../utils/common.js";

import LocalLoader from "../../Components/Loader/LocalLoader.js";
import { FilterWrapper } from "../../assets/styles/FilterStyle.js";

import animationData1 from "../../assets/lotties/question.json";

import { TableWrapper } from "../../Components/styledConstant.js";
import { useSelector } from "react-redux";
import { AlertWrapper } from "../../Components/Modal/style.js";
import ConfirmBox from "../../Components/ConfirmBox/ConfirmBox.jsx";
import TenantKycDetails from "./TenantKycDetails.jsx";
import MoreOptions from "../../Components/MoreOptions/MoreOptions.jsx";
require("react-datepicker/dist/react-datepicker.css");

const B2cUsers = () => {
  const [apiData, setApiData] = useState([]);

  const [totalPages, setTotalPages] = useState(null);
  const [totalElements, setTotalElements] = useState("");
  const [currPage, setCurrPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [pdfData_, setPdfData] = useState([]);
  const [downloadLoader, setDownloadLoader] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({});
  const [userName, setUserName] = useState("");
  const [status, setStatus] = useState("");
  const [userData, setUserData] = useState("");

  const [updateStatus, setUpdateStatus] = useState({});
  const [loginUserType, setLoginUserTye] = useState("");
  const [showfilter, setShowFilter] = useState("");
   
  const navigate = useNavigate();

  const link = useRef();

  const defaultOptions1 = {
    loop: true,
    autoplay: true,
    animationData: animationData1,
  };
 
  // Date Format
  var currentDate = new Date();
  var formattedDate = [
    currentDate.getDate(),
    currentDate.getMonth() + 1,
    currentDate.getFullYear(),
  ]
    .map((n) => (n < 10 ? `0${n}` : `${n}`))
    .join("-");

 
  const location = useLocation();
  const {mobileNumber} = location.state || {};

useEffect(()=>{
  if(mobileNumber){
    setUserData(mobileNumber)
    navigate(location.pathname, { replace: true });
  }

},[mobileNumber])



  const handleApiData = async (key,params) => {
    if (key === "CSV") {
      
        setDownloadLoader("CSV");
      } else if(key === "PDF") {
        setDownloadLoader("PDF");
      }else{
        setDownloadLoader("");
        setLoading(true);
      }

      const payload = {
        username:params?.username,
        status:params?.status,
        pageNo:params?.pageNo,
        pageSize:10
    }
      if(key === "PDF" || key === "CSV"){
     payload.pageSize = totalElements || 10000;
      }

      getCustomer(payload).then((resp) => {
        setLoading(false); 
        setDownloadLoader("");    
      
      if (resp?.data.success) {
   
        if (key === "CSV") {
          setPdfData(resp?.data?.data?.content);

          setTimeout(() => {
            const csvlink = link.current;
            csvlink.link.click();
          }, 100);
        } else if (key === "PDF") {
          
          userlistPdfData(resp?.data?.data?.content);
        } else {
          setCurrPage(params?.pageNo)
          setApiData(resp?.data?.data?.content);
          setTotalPages(resp?.data?.data?.totalPages);
          setTotalElements(resp?.data?.data?.totalElements);
          
        }
      }
    });
  };
  useEffect(() => {

    const params = {
      username: "",
      status: "",
      pageNo: 0,
    }
 
    handleApiData("",params);
  }, []);

  //API to Export PDF file

  const currentPage = (page) =>{
    const params = {
      username: userName,
      status: status,
      pageNo: page,
    }
    handleApiData("",params);
   setCurrPage(page);
  }

  

  const userlistPdfData = (data = []) => {

   

      const tableHeader = [
        {
          firstName: "First Name",
          lastName: "Last Name",
          userName: "UserName",
          createdBy: "Created By",
          createdDate:"Created Date",
          lastModifiedDate:"Last Modified Date",
          status:"Status",
        },
      ];
  
      pdfData(data, tableHeader, 'B2C-User-List',400);
    
  };


  const { user } = useSelector((state) => state.user);

  useEffect(() => {
    if (loginUserType === "" && !isEmpty(user?.userType)) {
      setLoginUserTye(user?.userType);
    }
  }, [user]);

  const updateUserStatus = (item) => {
  const payload = {
    userName:item?.userName,
    status:item?.status === "ACTIVE" ? "INACTIVE" : "ACTIVE",
}
setLoading(true)
updateCustomerStatus(payload).then((resp) =>{
  setLoading(false);
  setUpdateStatus({});
  if(resp?.data?.success){
    setMessage({ msg: resp?.data?.message, type: "success" });
    
    handleApiData("",{
      username: userName,
      status: status,
      pageNo: currPage,
    });
  }else{
    let msg = "";
          if (resp?.data?.errorCodeList.length > 0) {
            msg = resp?.data?.errorCodeList[0];
          } else {
            msg = resp?.data?.message;
          }
          setMessage({ msg: msg, type: "error" });
  }
}).catch((err) =>{
  setUpdateStatus({});
});

  }

  useEffect(()=>{
    if(isEmpty(message)) return
  const timerId =   setTimeout(() => {
      setMessage({});
    }, 5000);

    return(()=>{
      clearTimeout(timerId);
    })
  },[message])

  const statusList = [
    { label: "Select status", value: "" },
    { label: "Active", value: "ACTIVE" },
    { label: "Inactive", value: "INACTIVE" },
  ];

  const changStatus = (value) => {
    handleApiData("",{
      username: userName,
      status: value,
      pageNo: 0,
    });
    setCurrPage(0)
    setStatus(value);

  }

  const search = () => {
    console.log("search",userName)
    handleApiData("",{
      username: userName,
      status: status,
      pageNo: 0,
    });
    setCurrPage(0)
   

  }

  const refresh = () => {
    handleApiData("",{
      username: "",
      status: "",
      pageNo: 0,
    });

    setUserName("");
    setStatus("");
    setCurrPage(0);
  }
    const moreOptions = [
    {
      label:(item) =>item?.status === "ACTIVE"?"INACTIVE":"ACTIVE",
      click:(item)=> setUpdateStatus(item),
       show:()=>true
    },
    // {
    //   label:"Tenant KYC",
    //   click:(item)=>setUserData(item.userName),
    //   show:()=>true
    // },
 
  ]


  return (
    <>
 { !isEmpty(userData) &&  <TenantKycDetails userName={userData}  close={()=>setUserData("")}/>}

     {!isEmpty(message) && (
        <AlertWrapper className={`${message.type} globle`}>
          <span className="close" onClick={() => setMessage({})}>
            ×
          </span>
          {message.msg}
        </AlertWrapper>
      )}
    <div className="userlisthead_container">
      <div style={{ padding: "30px" }}>
        <div className="transaction_main_container">
          <div className="userlist_head">
            <div className="userlist_heading">
              <div className="userlist_left">
                <label>B2C Users List</label>
              </div>
              <div className="userlist_right">
                {downloadLoader !== "PDF" ? (
                  <button
                    className="pdf"
                    onClick={(e) => handleApiData("PDF", {
                      username: userName,
                      status: status,
                      pageNo: 0,
                    })}
                  >
                    PDF
                  </button>
                ) : (
                  <button className="pdf">
                    <div className="btn-loader">
                      <i className="fa-solid fa-spinner"></i>
                    </div>
                  </button>
                )}
                {downloadLoader !== "CSV" ? (
                  <button
                    className="xls"
                    onClick={(e) => handleApiData("CSV", {
                      username: userName,
                      status: status,
                      pageNo: 0,
                    })}
                  >
                    CSV
                  </button>
                ) : (
                  <button className="xls">
                    <div className="btn-loader">
                      <i className="fa-solid fa-spinner"></i>
                    </div>
                  </button>
                )}
                <CSVLink
                  ref={link}
                  data={pdfData_}
                  filename="B2C-User-List.csv"
                ></CSVLink>
              </div>
              <div className="userlist_filter">
                <button
                  className="filter fs-16"
                  onClick={(e) =>
                    showfilter === "active"
                      ? setShowFilter("")
                      : setShowFilter("active")
                  }
                >
                  <i className="fa-solid fa-filter"></i>
                </button>
              </div>
            </div>
          </div>
          <FilterWrapper
              style={{ height: "auto" }}
              className={`display_data ${showfilter}`}
            >
              <div className="filterBox">
                <div className="grow-1">
                  <div className="flex align-items gap-15">
                    <div className="input-field">
                      <select
                        className="input_select_field"
                        value={status}
                        onChange={(e) => changStatus(e.target.value)}
                      >
                   
                        {statusList.map((item) => (
                          <option value={item.value}>{item.label}</option>
                        ))}
                      </select>
                    </div>
               
                 

                    <div className="input-field">
                      <div className="flex">
                        <input
                          type="text"
                          placeholder="Username"
                          value={userName}
                          onChange={(e) => setUserName(e.target.value)}
                        />
                      </div>
                    </div>

                  

                    <div className=" button">
                      <button
                        className="userlist_btn"
                        onClick={search}
                        style={{ width: "100px" }}
                      >
                        Search
                      </button>
                    </div>
                    <div className="button">
                      <button
                        className="refresh-btn"
                        style={{ width: "60px" }}
                        onClick={refresh}
                      >
                        <i className="fa fa-refresh"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </FilterWrapper>
        </div>

        {apiData && (
          <div className="table-loader">
           {loading && <LocalLoader className="tableLoader" />}
            <TableWrapper className="table-card-wrapper">
             
              <table className="table">
                <thead>
             
                  <tr>
                    <th>S.No.</th>
                    <th>Name</th>
                    <th>UserName</th>
                    <th>Created By</th>
                    <th>Created Date</th>
                    <th>Last Modified Date</th>
                    <th>Status</th>
                    <th>Action</th>
                 
                  </tr>
                </thead>
                <tbody>
                  {apiData &&
                    apiData?.map((item, index) => {
                      const name = item?.firstName + " " + item?.lastName;
                      return (
                        <tr key={item.transactionId}>
                          <td className="td-none">
                            <span className="card-th">Sr No</span>
                            <span>{currPage * pageSize + index + 1}</span>
                          </td>

                          <td>
                            <span className="card-th">Name</span>
                            <span>
                              {name?.trim() || "-"}
                            </span>
                          </td>

                          <td>
                            <span className="card-th">UserName</span>
                            <span>{item?.userName || "-"}</span>
                          </td>
                         
                          <td>
                            <span className="card-th">Created By</span>
                            <span>{item?.createdBy || "-"}</span>
                          </td>

                          <td>
                            <span className="card-th">Created Date</span>
                            <span>{item?.createdDate || "-"}</span>
                          </td>
                          <td>
                            <span className="card-th">Last Modified Date</span>
                            <span>{item?.lastModifiedDate || "-"}</span>
                          </td>
                          <td>
                            <span className="card-th">Status</span>
                             <span>
                                <div
                                  className={`${
                                    item.status == "ACTIVE"
                                      ? "active_status"
                                      : "inactive_status"
                                  }`}
                                >
                                  {item?.status}
                                </div>
                              </span>
                          </td>
                        
                          <td className="user_action_btn">
                                <span className="card-th">Actions</span>
                                 <MoreOptions options={moreOptions} items={item} />
                                {/* <span className="center">
                                  <div
                                    className={`custom-toggle toggle_button ${
                                      item.status === "ACTIVE" ? "active" : ""
                                    }`}
                                    onClick={() =>
                                      setUpdateStatus(item)
                                    }
                                    styled={{
                                      margin: "0",
                                      marginRight: "12px",
                                    }}
                                  >
                                    <div className="slider"></div>
                                  </div>

                                </span>
                                  <span className="center" onClick={()=>setUserData(item.userName)}>
                                   view

                                </span> */}
                              </td>
                      
                      
                        </tr>
                      );
                    })}

                  {!loading && apiData && apiData.length < 1 && (
                    <tr>
                      <td
                        colSpan={6}
                        style={{ textAlign: "center", color: "red" }}
                      >
                        No data found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </TableWrapper>
          </div>
        )}

        {totalPages > 1 && (
          <Pagination
            items={apiData}
            itemsPerPage={pageSize}
            setitemsPerPage={setPageSize}
            currentPage={currPage}
            setcurrentPage={(page)=>currentPage(page)}
            totalPages={totalPages}
            forcePage={currPage}
          />
        )}
      </div>
  

      {!isEmpty(updateStatus) && (
           <ConfirmBox cancel={()=>setUpdateStatus({})} ok={() => updateUserStatus(updateStatus)}>
           <label>You want to {updateStatus?.status === "ACTIVE" ? "deactivate" : "activate"} this user?</label>
           </ConfirmBox>
      
      )}


     
    </div>
    </>
  );
};

export default B2cUsers;
